// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2ZCQo","unreadBadge":"styles_unreadBadge__1X4aK","modalContent":"styles_modalContent__1vYpb","modal":"styles_modal__2xOLq"};